/**
 * i18n 国际化配置
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  // 临时写死 zh-CN，暂不启用浏览器语言检测。
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // 关闭 i18next 官方支持提示，避免输出 Locize 宣传文案
    showSupportNotice: false,
    // 支持的语言
    supportedLngs: ['zh-CN', 'en-US', 'zh-TW'],
    // 临时统一使用简体中文，不读取浏览器语言或 i18nextLng 本地缓存。
    lng: 'zh-CN',
    // 默认语言
    fallbackLng: 'zh-CN',
    // 默认命名空间
    defaultNS: 'common',
    // 命名空间列表
    ns: ['common', 'editor', 'settings', 'errors'],
    // 原浏览器语言检测配置，临时保留注释，恢复多语言自动检测时取消注释。
    // detection: {
    //   order: ['localStorage', 'navigator'],
    //   caches: ['localStorage'],
    //   lookupLocalStorage: 'i18nextLng',
    // },
    // 后端配置（queryStringParams 基于构建时间戳做 cache busting，避免浏览器缓存旧翻译）
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: { v: import.meta.env.VITE_BUILD_TIME },
    },
    // React 配置
    react: {
      useSuspense: true,
    },
    // 插值配置
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
